/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgMTJWMTEuMkg0LjQzMjc1VjEySDEzWk0xLjUzMDgxIDEwLjI3N0w0LjYzMTY5IDdMMS41MzA4MSAzLjczODRMMSA0LjMwNDZMMy41NzAyNSA3TDEgOS43MTA4TDEuNTMwODEgMTAuMjc3Wk0xMyA3LjRWNi42SDYuNTY3MjVWNy40SDEzWk0xMyAyLjhWMkg0LjQzMjc1VjIuOEgxM1oiIGZpbGw9ImJsYWNrIi8+PC9zdmc+";